import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const ListboxFooter = forwardRef(function ListboxFooter(
  { children, loadingMore = false, ...other },
  ref
) {
  return (
    <ul ref={ref} {...other}>
      {children}
      {loadingMore ? (
        <Box
          component="li"
          sx={{ display: 'flex', justifyContent: 'center', py: 1, listStyle: 'none' }}
        >
          <CircularProgress size={16} />
          <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
            Loading more...
          </Typography>
        </Box>
      ) : null}
    </ul>
  );
});

export default ListboxFooter;
